const profile = {
  name: "Clinton Ugochukwu Onuigbo",
  role: "Senior Software Engineer",
  email: "clinton.onuigbo8310@gmail.com",
  picture: "assets/images/IMG_-ywdefa.jpg",
  website: "",
  phones: {
    airtel: "+2348075941561",
    mtn: "+2347034458310",
  },
  bio: "Hi, my name is Clinton Onuigbo. A strong test-driven software developer.With an over 7 years experience in front-end, backend development, web3 frontent and proficient in modern JavaScript stacks using tools like TypeScript, JavaScript, React/Redux, Nodejs, Web3 js, Ethers js, Nextjs, Express js, Mongodb, AWS, PHP and MySQL. I’ve developed multiple applications that generates revenue for my previous employers",
  features: [
    {
      image: "assets/icons/browser-web-development-svgrepo-com.svg",
      title: "BackEnd Web Development",
      description:
        "High-quality and professional development of websites at the professional level. I currently work with Hackpiy as the CTO.",
    },
    {
      image: "assets/icons/web-design-svgrepo-com.svg",
      title: "Frontend Web Development",
      description: "I work with product designers to deliver super intuitive frotend application for my clients.",
    },
    {
      image: "assets/icons/link-chain-svgrepo-com.svg",
      title: "Web3 Development",
      description:
        "I have worked on web3 projects as a web3 frontend developer and solidity developer to create PrimeDEX, Garaswap applications.",
    },
  ],
  keyCompetence: [
    {
      title: "Backend",
      list: [
        {
          language: "Advanced PHP",
          level: 95,
        },
        {
          language: "Express JS",
          level: 90,
        },
        {
          language: "Node JS",
          level: 89,
        },
        {
          language: "Solidity",
          level: 50,
        },
        {
          language: "Rest API",
          level: 90,
        },
      ],
    },
    {
      title: "Frontend",
      list: [
        {
          language: "React JS/Next JS",
          level: 96,
        },
        {
          language: "Vanilla JavaScript (ES6)",
          level: 96,
        },
        {
          language: "TypeScript",
          level: 98,
        },
        {
          language: "Pure JQuery JS",
          level: 95,
        },
        {
          language: "HTML, XML, SVG & CSS",
          level: 98,
        },
      ],
    },
    {
      title: "Web3 & Blockchain",
      list: [
        {
          language: "Ethers.js",
          level: 90,
        },
        {
          language: "Web3 Js",
          level: 90,
        },
        {
          language: "Truffle | Ganache",
          level: 80,
        },
        {
          language: "Solidity",
          level: 80,
        },
      ],
    },
    {
      title: "DataBases",
      list: [
        {
          language: "MySQL Database",
          level: 89,
        },
        {
          language: "FireBase",
          level: 45,
        },
        {
          language: "MongoDB",
          level: 66,
        },
      ],
    },
    {
      title: "Operations",
      list: [
        {
          language: "Git & GitHub",
          level: 97,
        },
        {
          language: "Hostinger CI/CD",
          level: 100,
        },
        {
          language: "AWS",
          level: 45,
        },
      ],
    },
  ],
  portfolio: [
    {
      image: "assets/images/primedex.png",
      title: "PrimeDex",
      category: "Blockchain",
      description: "A Decetralized Exchange currently running ICO",
      link: "https://primedex.io/",
      disabled: false,
      stack: "Nextjs, Web3js, Ethers.js, Solidity, Bianance SmartChain",
    },
    {
      image: "assets/images/nairagram-c2c.png",
      title: "Nairagram C2C",
      category: "Finance | Web3",
      description: "Send money to Nigeria and Ghana with ease",
      link: "https://paidby.app/",
      disabled: true,
      stack: "React js, Typescript.js, Web3.js",
    },
    {
      image: "assets/images/codelandcs.png",
      title: "Codeland CS",
      category: "Education",
      description: "Online school for creatives seeking to learn a new skill.",
      link: "https://guileless-platypus-c6f876.netlify.app/",
      disabled: false,
      stack: "Reactjs, Typescript, Lumen",
    },

    {
      image: "assets/images/paidby.png",
      title: "Paidby",
      category: "Finance",
      description: "Payment Processing Secured with Engagement Contract",
      link: "https://paidby.app/",
      disabled: false,
      stack: "Nextjs, Typescript.js, Web3.js, Lumen",
    },
    {
      image: "assets/images/nairagram-b2b.png",
      title: "Nairagram B2B",
      category: "Finance",
      description: "Receive money from USA and Canada",
      link: "https://paidby.app/",
      disabled: true,
      stack: "React js, Typescript.js, Web3.js",
    },

    {
      image: "assets/images/avondex.png",
      title: "Avondex Capital",
      category: "Finance",
      description: "Crypto Investments, Forex Investments",
      link: "https://avondexcapital.ltd",
      disabled: false,
      stack: "HTML, CSS, JavaScript (jQuery), PHP, MySQL",
    },
    {
      image: "assets/images/potto.png",
      title: "Potto Solution",
      category: "Education",
      description: "SCHOOL BIOMETRIC SOLUTION!",
      link: "https://potto.ng/",
      disabled: false,
      stack: "HTML5, CSS3, JavaScript",
    },
    {
      image: "assets/images/ahiamoni.png",
      title: "Ahiamoni",
      category: "E-Commerce",
      description: "Online Stores, Product Listing and Adverts",
      link: "https://ahiamoni.com",
      disabled: true,
      stack: "HTML, CSS, JavaScript (jQuery), PHP, MySQL",
    },
    {
      image: "assets/images/geohomes.png",
      title: "GeoHomes Group",
      category: "Real Estates",
      description: "Residential Developments, Commercial Developments and Estate Planing",
      link: "https://geohomesgroup.com",
      disabled: false,
      stack: "HTML, CSS, JavaScript (jQuery), PHP, MySQL",
    },
    {
      image: "assets/images/lendtrx-wallet.png",
      title: "LendTRX Wallet",
      category: "Blockchain",
      description: "OffChain Wallet, Send, Recieve and Swap Crypto.",
      link: "https://lendtrx.com",
      disabled: false,
      stack: "Reactjs, Web3js, Solidity, Nodejs, MongoDB, Ethereum Blockchain",
    },
  ],
};

export default profile;
